
  import { Vue, Component, Prop, Watch } from "vue-property-decorator";
  import DropdownFilter from "@/components/filters/DropdownFilterNew.vue";
  import GET_PROJECTS from "@/apollo/autocomplete-queries/GetProjects.gql";
  import { Query_RootProjectArgs } from "@/generated/graphql";
  import filterMultiselectItems from "@/helpers/multiselect/filterMultiselectItems";
  import getProjectDropdownOptions from "@/helpers/multiselect/getProjectDropdownOptions";
  import ProjectsMultiselectOption from "@/entities/ProjectsMultiselectOption";
  import MultiselectTag from "@/components/autocompleteMultiselects/MultiselectTagNew.vue";
  import ProjectMultiselectOption from "@/components/autocompleteMultiselects/ProjectMultiselectOption.vue";

  @Component({
    components: {
      ProjectMultiselectOption,
      MultiselectTag,
      DropdownFilter,
    },
    apollo: {
      projects: {
        query: GET_PROJECTS,
        variables() {
          return this.projectAutocompleteFilter;
        },
        update(data) {
          return getProjectDropdownOptions(data.project);
        },
        skip() {
          return !this.projectSearchString;
        },
      },
    },
  })

  export default class ProjectsMultiselect extends Vue {
    @Prop({ type: Array, required: true }) value!: string[];
    @Prop({ type: Boolean, default: false }) processing!: boolean;
    @Prop({ type: Boolean, default: false }) single!: boolean;
    @Prop({ type: Array, default: () => [] }) projectsConditions!: Object[];
    @Prop({ type: String , default: undefined}) readonly placeholder?: string;
    @Prop({ type: Boolean, default: false }) readonly invalid!: boolean;
    @Prop({ type: Boolean, default: false }) readonly selectedInline!: boolean;
    @Prop({ type: Boolean, default: false }) readonly withoutLoading!: boolean;
    @Prop({ type: Number, default: undefined }) readonly max!: number;
    @Prop({ type: String, default: "" }) readonly getcontainerStyle?: string;

    projects: ProjectsMultiselectOption[] = [];
    chosenProjects: ProjectsMultiselectOption[] = [];
    projectSearchString = "";

    get placeholderText(): string {
      return this.placeholder ? this.placeholder : "Client";
    }

    get projectAutocompleteFilter(): Query_RootProjectArgs {
      const conditions: any[] = [
        ...this.projectsConditions,
        {
          name: {
            _ilike: `%${this.projectSearchString}%`,
          },
        },
      ];

      if (this.value.length) {
        conditions.push(
          {
            id: {
              _nin: this.value,
            },
          },
        );
      }

      return {
        where: {_and: conditions},
        limit: 5,
      };
    }

    @Watch('value', {immediate: true})
    async onProjectsIdsChanged(): Promise<void> {
      const projectsIds = this.value;

      if (projectsIds.length === 0) {
        this.chosenProjects = [];
      }

      const {
        newItemsIds: newProjectsIds,
        previouslyChosenItems: previouslyChosenProjects,
      } = filterMultiselectItems<ProjectsMultiselectOption>(projectsIds, this.chosenProjects);

      if (newProjectsIds.length === 0) {
        return;
      }

      const rawData = await this.$apollo.query({
        query: GET_PROJECTS,
        variables: {
          where: {
            id: {
              _in: newProjectsIds,
            },
          },
        },
      })

      const newChosenProjects = getProjectDropdownOptions(rawData.data.project);

      this.chosenProjects = [...previouslyChosenProjects, ...newChosenProjects];
    }

    handleInput(chosenProjects: ProjectsMultiselectOption[]): void {
      this.chosenProjects = chosenProjects;
      const chosenProjectsIds = chosenProjects.map(option => option.id);

      this.$emit("input", chosenProjectsIds);
    }
  }
